import { Box, styled, Typography } from "@mui/material";

export const ActiveGamesIndicatorContainer = styled(Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "16px",
});

export const ActiveGamesIndicatorTypography = styled(Typography)({
    fontSize: "0.9em",
    fontWeight: "bold",
    color: "var(--community-active-game-in-progress)",
});

export const LiveDot = styled(Box)({
    backgroundColor: "var(--community-active-game-in-progress)",
    borderRadius: "50%",
    boxShadow: "0 0 0 0 var(--community-active-game-in-progress)",
    height: "14px",
    width: "14px",
    margin: "4px",
    animation: "pulse-green 1.2s infinite",
    "@keyframes pulse-green": {
        "0%": {
            transform: "scale(0.6)",
            boxShadow: "0 0 0 0 rgba(68, 183, 0, 0.7)",
        },
        "70%": {
            transform: "scale(0.65)",
            boxShadow: "0 0 0 10px rgba(68, 183, 0, 0)",
        },
        "100%": {
            transform: "scale(0.6)",
            boxShadow: "0 0 0 0 rgba(68, 183, 0, 0)",
        },
    },
});
